import { Trans, useTranslation } from 'next-i18next'
import { without } from 'ramda'

import {
  Heading2,
  LinkGrid,
  LinkText,
  Section2
} from '@/features/Listings/seo/elements'
import useFilterSlug from '@/features/Listings/seo/search-results-content/content/use-filter-slug'
import {
  getPopularCitiesByState,
  toTitleCase
} from '@/features/Listings/seo/search-results-content/content/utils'
import { CityData } from '@/features/Listings/seo/types'
import { Label } from '@/components/text'

const NearbyCities = ({
  cityData,
  cityNameWithState,
  filterSlug
}: {
  cityData: CityData
  cityNameWithState: string
  filterSlug: string
}) => {
  const { t } = useTranslation()
  const { state, slug: citySlug } = cityData
  const cityLinks = getPopularCitiesByState(state)
  const { hasFilter, filterName } = useFilterSlug(filterSlug)

  const filterNameWithFallback = hasFilter
    ? toTitleCase(filterName)
    : t('seo.pois:Apartments, Houses & Rooms for Rent')

  const linkFilterNameWithFallback = hasFilter
    ? filterName
    : t('seo.pois:apartments for rent')

  return (
    <Section2>
      <Heading2>
        <Trans
          i18nKey="seo.pois:Nearby Cities w Filter LOCATION"
          values={{
            filterName: filterNameWithFallback,
            location: cityNameWithState
          }}
          defaults="{{ filterName }} Near {{ location }}"
        />
      </Heading2>
      <LinkGrid linksOnly>
        {without([citySlug], cityLinks).map(slug => {
          const name = t(`cities:city_name_${slug}`)
          const link = `/rental-listings/city/${slug}${
            filterSlug ? `/${filterSlug}` : ''
          }`
          return (
            <Label key={link} fontSize="14px">
              <LinkText href={link}>
                <Trans
                  i18nKey="seo.pois:nearby city apartments for rent"
                  values={{
                    filterName: linkFilterNameWithFallback,
                    cityName: name
                  }}
                  defaults="{{ cityName }} {{ filterName }}"
                />
              </LinkText>
            </Label>
          )
        })}
      </LinkGrid>
    </Section2>
  )
}

export default NearbyCities
